export default {
  install(Vue, options) {
    Vue.prototype.confirm = async function(text, buttons) {
      // Enter ile formu onayladığımız zaman input kısmı blur olmadığı için değiştirilebiliyordu bug a sebeb olmaması için eklendi
      let el = this.$el.querySelector(":focus");
      if (el) el.blur();

      const button = {
        no: this.$t("common.no"),
        yes: this.$t("common.yes"),
        ...buttons,
      };
      return new Promise((resolve) => {
        this.$confirm({
          message: text,
          button,
          callback: (confirm) => {
            if (confirm) {
              resolve(true);
            } else {
              resolve(false);
            }
          },
        });
      });
    };
  },
};
